module.exports = __webpack_public_path__ + "img/tooth-carious.9177e167.svg";